import { formatValue, lengthLimit, valuePlaceholder, showLoader, printWorkAround, helpText } from '../data-viz-helpers.js'

customElements.define('zero-simple-metric', class extends HTMLElement {
    static observedAttributes = ['data-value', 'data-label', 'data-history', 'data-history-labels', 'data-bg', 'data-fill', 'data-help', 'data-format']

    constructor() {
        super().attachShadow({mode: 'open'})

        this.height = 40
        this.width = 300
    }

    connectedCallback() {
        this.getProps()
        this.shadowRoot.innerHTML = showLoader([this.dataset.value], this.render())
        this.interaction()
    }

    attributeChangedCallback(_, oldVal, newVal) {
        if(oldVal !== newVal) {
            this.connectedCallback()
        }
    }

    interaction() {
        const val = this.shadowRoot.querySelector('[data-val]')
        const label = this.shadowRoot.querySelector('[data-label]')
        const historyPoints = this.shadowRoot.querySelectorAll('.point')
        
        historyPoints.forEach((item, idx) => {
            item.addEventListener('pointerover', () => {
                val.textContent = item.dataset.val
                label.textContent = lengthLimit(this.historyLabels[idx], 26)
            })

            item.addEventListener('pointerout', () => {
                val.textContent = this.value
                label.textContent = this.label
            })
        })
    }

    getProps() {
        this.bg = this.dataset.bg ?? 'var(--color-4-lt)'
        this.fill = this.dataset.fill ?? 'var(--color-4-dk)'
        this.format = this.dataset.format ?? ''
        this.label = this.dataset.label ?? ''
        this.value = formatValue(this.dataset.value, this.format) ?? ''
        this.history = this.dataset.history?.split(/,\s?/).slice(0,12) ?? []
        this.historyLabels = this.dataset.historyLabels?.split(/,\s?/).slice(0,12) ?? []
    }

    createHistoryGraph() {
        if(!this.hasAttribute('data-history')) return

        const pointCount = this.history.length
        const topline = 0
        const baseline = this.height
        const maxHeight = baseline - topline
        const points = []
    
        this.history.forEach((val, idx) => {
            const maxVal = Math.max(...this.history)
            const x = (idx * (this.width / (pointCount - 1)))
            const y = baseline - (maxHeight * (val / maxVal))
 
            points.push(`${x},${y}`)
        })

        const dots = points.map((item, idx) => {
            const [x] = item.split(',')
            const width = this.width / (points.length - 2)

            return `
                <rect 
                    class="point"
                    x="${x - (width / 2)}"
                    y="${topline}"
                    width="${width}"
                    height="${maxHeight * 2}"
                    fill="${this.fill}"
                    rx="${width / 6}"
                    data-val="${formatValue(this.history[idx], this.format)}"></rect>
            `
        })

        return `
            <svg 
                class="chart"
                xmlns="http://www.w3.org/2000/svg" 
                version="1.1"
                viewBox="0 0 ${this.width} ${this.height}">

                <polygon points="${0},${baseline} ${points.join(' ')} ${this.width},${baseline}" fill="${this.fill}" style="opacity: 0.2;"></polygon>
                <polyline points=" ${points.join(' ')}" fill="none" stroke="${this.fill}" stroke-width="2"></polyline>
                ${dots.join('')}

            </svg>
        `
    }

    render() {
        return `
            <style>
                * {
                    box-sizing: border-box;
                }

                :host {
                    background-color: ${this.bg};
                    border-radius: var(--chart-radius);
                    container-type: inline-size;
                    display: grid;
                    height: 100%;
                    overflow: clip;
                    place-content: center;
                    position: relative;
                    -webkit-user-select: none;
                    user-select: none;
                }

                p {
                    all: unset;
                }

                .value {
                    color: ${this.fill};
                    font-size: 18cqw;
                    font-weight: 900;
                    text-align: center;
                }

                .label {
                    color: ${this.fill};
                    font-size: 6cqw;
                    font-weight: 700;
                    text-align: center;
                }

                .chart {
                    inset: auto 0 0 0;
                    margin-inline: auto;
                    position: absolute;
                    width: 100%;
                }

                .point {
                    opacity: 0;

                    &:hover {
                        opacity: 0.1;
                    }
                }
            </style>

            ${printWorkAround(this)}

            <p data-val class="value">${valuePlaceholder(this.value)}</p>
            <p data-label class="label">${lengthLimit(this.label, 26)}</p>

            ${this.createHistoryGraph()}

            ${helpText(this)}
        `
    }
})